import React, { createContext, useContext, useState } from "react";
import Modal from "../components/Modal";

const ModalContext = createContext();

export function useModal() {
    return useContext(ModalContext);
}

export function ModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [modalWidth, setModalWidth] = useState("auto");

    const openModal = (content, width = "auto") => {
        setModalContent(content);
        setModalWidth(width);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        // Allow time for animation to complete before removing content
        setTimeout(() => setModalContent(null), 300);
    };

    return (
        <ModalContext.Provider value={{ isOpen, openModal, closeModal }}>
            {children}
            <Modal isOpen={isOpen} onClose={closeModal} width={modalWidth}>
                {modalContent}
            </Modal>
        </ModalContext.Provider>
    );
}
